import { render, staticRenderFns } from "./RegistrationSearch.vue?vue&type=template&id=733e9708&scoped=true&"
import script from "./RegistrationSearch.vue?vue&type=script&lang=js&"
export * from "./RegistrationSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733e9708",
  null
  
)

export default component.exports